"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _alloyReactProgressRing = _interopRequireDefault(require("@adsk/alloy-react-progress-ring"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const LoadingContentSwitch = _ref => {
  let {
    children,
    showContent
  } = _ref;
  if (!showContent) {
    return /*#__PURE__*/_react.default.createElement(StyledProgressRing, null);
  } else {
    return children;
  }
};
const StyledProgressRing = (0, _styledComponents.default)(_alloyReactProgressRing.default)`
  display: block;
  margin: auto;
`;
LoadingContentSwitch.propTypes = {
  children: _propTypes.default.node,
  showContent: _propTypes.default.bool
};
var _default = exports.default = LoadingContentSwitch;